module.exports = __webpack_public_path__ + "static/media/allFilterIconPink.191cc04f.svg";